<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "INTERESTS.TITLE" | translate }}</div>
</mat-toolbar>

<mat-card>
    <mat-card-content>
        <button
            [id]="'button_profile-interests_EditarSalvar'"
            mat-mini-fab
            color="primary"
            (click)="toggleEdition()"
            class="edition-button"
        >
            <mat-icon aria-label="label">{{ editMode ? "save" : "create" }}</mat-icon>
        </button>

        <div class="form-container">
            <mat-card>
                <mat-card-content>
                    <mat-chip-list color="primary" [multiple]="true">
                        <mat-chip
                            *ngFor="let tag of tags"
                            (click)="selectMainTag(tag.id)"
                            [selected]="tag.selected"
                            [disabled]="!editMode"
                        >
                            {{ tag.nome }}
                        </mat-chip>
                    </mat-chip-list>
                </mat-card-content>
            </mat-card>

            <mat-card *ngFor="let tag of getSelectedTags(); let i = index" style="margin-top: 25px">
                <mat-card-header>
                    <mat-card-title>
                        {{ tag.nome }}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-chip-list color="primary" [multiple]="true">
                        <mat-chip
                            *ngFor="let child of tag.subCategorias"
                            (click)="editMode ? selectChildrenTag(tag.id, child.id) : null"
                            [selected]="child.selected"
                            [disabled]="!editMode"
                        >
                            {{ child.nome }}
                        </mat-chip>
                    </mat-chip-list>
                </mat-card-content>
            </mat-card>
        </div>
    </mat-card-content>
</mat-card>
